import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/vos/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard implements CanActivate {
  constructor(private authService: AuthService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const user = JSON.parse(this.authService.getUserLoggedIn());

    const empresa_id = this.findNestedObj(user, 'empresa_id');

    return empresa_id == 2;
  }

  findNestedObj(object: unknown, key: string) {
    let value: any;
    JSON.stringify(object, (objectKey, nestedValue) => {
      if (objectKey === key) {
        value = nestedValue;
      }
      return nestedValue;
    });

    return value;
  }
}
